const ENExternalAccessKeys = {
	"Chaves de acesso externo": "External access keys",
	"Nova chave de acesso externo" : "New external access key",
	"Gerar chave de acesso externo": "Generate external access key",
	"Deseja gerar uma chave de acesso": "Do you want to generate a passkey",
	"Deseja realmente finalizar a sessão": "Do you really want to end the session",
	"Finalizar sessão": "End session",
	"Criador": "Creator",
	"Usuário que acessou": "User who accessed",
	"Chave de acesso": "Access key",
	"Erro ao gerar chave de acesso": "Error generating access key",
	"Sessão finalizada com sucesso": "Session ended successfully",
	"Erro ao finalizar sessão": "Error ending session",
	"A chave é valida para acesso somente pelas próximas duas horas ou até você finalizá-la pela opção Finalizar Sessão": "The key is valid for access only for the next two hours or until you finish using the finish option"
};

export default ENExternalAccessKeys;
